// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".web-3d-viewer[data-v-20073c1a]{width:100%;height:270px}.el-overlay-dialog .configurator-layout .side-summary .el-overlay.in-lightbox-shadow .el-dialog.is-fullscreen .in-lightbox .web-3d-viewer[data-v-20073c1a]{height:85%;width:85%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
